import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Helmet } from 'react-helmet-async';
import axios from 'axios';
// @mui
import { styled } from '@mui/material/styles';
import { Stack, Typography, Button } from '@mui/material';
// 다국어
import { useTranslation } from 'react-i18next';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
// component
import PageHeader from '../components/sectionComponent/PageHeader';
import MypageDashBoard from '../components/MypageComponents/MypageDashBoard';
import SetProgile from '../components/MypageComponents/SetProfile';
import LicenseManage from '../components/MypageComponents/LicenseManage';
import PaymentInfo from '../components/MypageComponents/PaymentInfo';
import ComposeGroup from '../components/MypageComponents/ComposeGroup';

const StyledToggleGroup = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  textAlign: 'center',
  padding: '56px 0',
  backgroundColor: '#f5f5f5',
  '& .Mui-selected': {
    backgroundColor: '#1a9ef8 !important',
    color: '#fff !important',
  },
}));

const StyledToggleButton = styled(ToggleButton)(() => ({
  padding: '12px 50px',
  fontFamily: 'Pretendard-Regular',
  borderRadius: '30px !important',
  margin: '0 0.5rem !important',
  backgroundColor: 'white',
  color: 'black',
  border: 'none !important',
  boxShadow: ' 0px 4px 20px rgb(0 0 0 / 5%)',
  fontSize: '1.2rem',
  '&:hover': {
    backgroundColor: '#1a9ef8',
    color: 'white',
  },
}));

export default function MyPage() {
  // 다국어
  const { t, i18n } = useTranslation(['page']);

  // 로그인 여부 체크
  const navigate = useNavigate();

  if (!sessionStorage.getItem('login_info')) {
    alert('로그인 후 이용 가능합니다.');
    navigate('/login', { replace: true });
  }

  useEffect(() => {
    const userInfo = JSON.parse(sessionStorage.getItem('login_info'));

    if (userInfo !== null) {
      // 여기에 그룹 id 가져오는 axios 만들기
      axios
        .post(`${process.env.REACT_APP_SERVER_URL}/user/regist/${userInfo.user_token}`)
        .then((response) => {
          if (response.data[0][0]) {
            // console.log('response', response.data[0][0]);
            sessionStorage.setItem('org_id', response.data[0][0].org_id);
            setUserData(JSON.parse(sessionStorage.getItem('login_info')));
            setMaster(response.data[0][0].org_authority);
          }
        })
        .catch((response) => {
          console.log(response);
        });
    }
  }, []);

  // -------------------------------------------------------------------

  const [tabType, setTabType] = useState('dashBoard');

  const [userData, setUserData] = useState([]);

  const [Master, setMaster] = useState('');

  const [alignment, setAlignment] = React.useState('dashBoard');

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  // -------------------------------------------------------------------

  return (
    <>
      <Helmet>
        <title> MyPage | RainDrop </title>
      </Helmet>
      <PageHeader data="마이페이지" />
      <StyledToggleGroup>
        <ToggleButtonGroup color="primary" value={alignment} exclusive onChange={handleChange} aria-label="Platform">
          <StyledToggleButton
            value="dashBoard"
            variant="contained"
            type="button"
            onClick={() => {
              setTabType('dashBoard');
            }}
          >
            {t('대시보드')}
          </StyledToggleButton>
          <StyledToggleButton
            value="pofile"
            variant="contained"
            type="button"
            onClick={() => {
              setTabType('pofile');
            }}
          >
            {t('프로필 설정')}
          </StyledToggleButton>
          <StyledToggleButton
            value="license"
            variant="contained"
            type="button"
            onClick={() => {
              setTabType('license');
            }}
          >
            {t('라이센스 관리')}
          </StyledToggleButton>
        </ToggleButtonGroup>
        {Master === 'MASTER' ? (
          <ToggleButtonGroup color="primary" value={alignment} exclusive onChange={handleChange} aria-label="Platform">
            <StyledToggleButton
              value="payment"
              variant="contained"
              type="button"
              onClick={() => {
                setTabType('payment');
              }}
            >
              {t('결제 정보')}
            </StyledToggleButton>
            <StyledToggleButton
              value="organization"
              variant="contained"
              type="button"
              onClick={() => {
                setTabType('organization');
              }}
            >
              {t('조직 구성')}
            </StyledToggleButton>
          </ToggleButtonGroup>
        ) : null}
      </StyledToggleGroup>
      <div style={{ paddingBottom: '60px', backgroundColor: '#f5f5f5' }}>
        {tabType === 'dashBoard' && <MypageDashBoard data={userData} />}
        {tabType === 'pofile' && <SetProgile data={userData} />}
        {tabType === 'license' && <LicenseManage data={userData} />}
        {tabType === 'payment' && <PaymentInfo data={userData} />}
        {tabType === 'organization' && <ComposeGroup data={userData} />}
      </div>
    </>
  );
}
